import React from 'react';
import FBCtmAdsSlideoutBannerWhiteSrc from './FBCtmAdsSlideoutBanner_white.png';

export const FBCtmAdsSlideoutBanner = () => {
  return <img src={FBCtmAdsSlideoutBannerWhiteSrc} />;
};
